export default __webpack_public_path__ + "static/media/ClickSobreCategoriaDelGrafico.f1421ff6.png";